import React from 'react';

import { useIntl } from 'react-intl';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import { Title, Wrapper } from './delivery-cancellation-policy.styled';

export default () => {
  const { formatMessage } = useIntl();
  const isEnabled = useFlag(LaunchDarklyFlag.ENABLE_DELIVERY_CANCELLATION_POLICY);
  if (!isEnabled) {
    return null;
  }
  return (
    <Wrapper>
      <Title>{formatMessage({ id: 'cancellationPolicyTitle' })}</Title>
      <p>{formatMessage({ id: 'cancellationPolicy' })}</p>
    </Wrapper>
  );
};
